import React from "react";
import StaticContentPage from "./StaticContentPage";
import { fraudSpamPolicyText } from "../data/staticPagesContent";

const FraudSpamPolicy = () => {
  return (
    <StaticContentPage
      title="Fraud & Spam Policy"
      seoTitle="Fraud & Spam Policy | Eveness"
      seoDescription="Read the Eveness fraud and spam policy, including prohibited activity, account protection, and platform safety rules."
      canonicalPath="/policies/fraud-spam-policy"
    >
      {fraudSpamPolicyText}
    </StaticContentPage>
  );
};

export default FraudSpamPolicy;